<template>
  <div class="answer--file"
       @contextmenu.prevent.stop="onContextmenu">
    <div class="file-list">
      <!--   todo ci 501919 遇到跳过的题目将没有 files, 参考题目时出现   -->
      <div v-if="files && files.length">
        <div v-if="eqType('record')">
          <audio v-show="recordUrl"
                 :src="recordUrl|ossHost"
                 controls
                 autoplay
                 style="width: 300px;">
            您的浏览器不支持 audio 标签。
          </audio>
        </div>
        <ul>
          <template v-for="(file, index) in prependFiles">
            <li @click="onPrependView(index)">
              <answer-file
                :type="type"
                :file="file"
                :index="index"/>
            </li>
            <li v-if="prependFiles.length === index+1"
                class="file-separate-line"></li>
          </template>
          <li v-for="(file, index) in files"
              :key="uniqueId + index"
              @click="onCheck(index)"
              @contextmenu.prevent.stop="(event)=>{onContextmenu(event, index)}">
            <answer-file
              :type="type"
              :file="file"
              :index="index"
              :checked="checkedFiles.includes(file)"/>
          </li>
        </ul>
      </div>
      <div v-else
           class="empty-text">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import AnswerFileFullScreen from '../../components/AnswerFileFullScreen'
import OrderRecordAudioViewer from '../../components/OrderRecordAudioViewer'
import AnswerFile from '@/views/question-review/packages/AnswerFileList/AnswerFile'
import ContextMenu from '../../components/ContextMenu'
import store from '@store'

export default {
  components: {AnswerFile},
  mixins: [],
  props: {
    questionIndex: Number,
    question: Object,
    type: String,
    prependFiles: Array,
    files: Array,
    contextMenuContainer: Element,
    getLableData: Function,
  },
  data () {
    return {
      recordUrl: null,
      checkMode: false,
      uniqueId: _.uniqueId(),
      checkedFiles: [],
    }
  },
  computed: {
    isMacOS () {
      return navigator.platform.indexOf('Mac') === 0
    },
    controlKeyCode () {
      return this.isMacOS ? 91 : 17
    },
  },
  watch: {},
  beforeCreate () {},
  created () {
    this.addEventListener()
    this.$nextTick(() => {})
  },
  mounted () {
    ContextMenu({})
  },
  destroyed () {
    this.removeEventListener()
  },
  methods: {
    ...Vuex.mapActions([]),
    onView (index) {
      if (this.eqType('record')) {
        OrderRecordAudioViewer.open({
          question: this.question,
          questionIndex: this.questionIndex,
          files: this.files,
          viewIndex: index,
          toolbar: {delete: false, label: true},
          getLableData: this.getLableData,
          orderDetail: (store.state.orderReview && store.state.orderReview.orderDetail) || {},
        })
        return
      }
      // 参考区只读：不传 orderDetail，打开前单例也会清空，避免可标注状态残留
      AnswerFileFullScreen({
        question: this.question,
        questionIndex: this.questionIndex,
        files: this.files,
        viewIndex: index,
        type: this.type,
        toolbar: {delete: false, label: true},
        getLableData: this.getLableData,
        orderDetail: {},
      })
    },
    onPrependView (index) {
      if (this.eqType('record')) {
        OrderRecordAudioViewer.open({
          question: this.question,
          questionIndex: this.questionIndex,
          files: this.prependFiles,
          viewIndex: index,
          orderDetail: (store.state.orderReview && store.state.orderReview.orderDetail) || {},
        })
        return
      }
      AnswerFileFullScreen({
        question: this.question,
        questionIndex: this.questionIndex,
        files: this.prependFiles,
        viewIndex: index,
        type: this.type,
        orderDetail: {},
      })
    },
    eqType (type) {
      return this.type === type
    },
    onContextmenu ({clientX, clientY}, index) {
      ContextMenu({readOnly: true})
      // 匹配右击菜单作用域
      ContextMenu().scope !== this.uniqueId && ContextMenu().empty()
      // 判断右击是否在项目上
      if (Number.isInteger(index) && index >= 0) {
        let file = this.files[index]
        if (!this.checkedFiles.includes(file)) {
          ContextMenu().empty()
          ContextMenu().checked(file)
          this.checkedFiles = ContextMenu().checkedFiles
        }
      } else {
        ContextMenu().empty()
      }
      ContextMenu().setScope(this.uniqueId)
      ContextMenu().setType(this.type)
      ContextMenu().setFiles(this.files)
      ContextMenu().show(clientX, clientY)
    },
    onCheck (index) {
      ContextMenu().hide()
      if (this.checkMode) {
        ContextMenu().checked(this.files[index])
      } else {
        this.onView(index)
      }
    },
    addEventListener () {
      document.addEventListener('keydown', this.keydown)
      document.addEventListener('keyup', this.keyup)
      document.addEventListener('click', this.clickDoc)
      document.addEventListener('visibilitychange', this.visibilityChange)
    },
    removeEventListener () {
      document.removeEventListener('keydown', this.keydown)
      document.removeEventListener('keyup', this.keyup)
      document.removeEventListener('click', this.clickDoc)
      document.removeEventListener('visibilitychange', this.visibilityChange)
    },
    keyup (event) {
      let control = this.controlKeyCode
      switch (event.keyCode || event.which || event.charCode) {
        // Control
        case control:
          this.checkMode = false
          break
      }
    },
    keydown (event) {
      let control = this.controlKeyCode
      switch (event.keyCode || event.which || event.charCode) {
        // Control
        case control:
          this.checkMode = true
          break
      }
    },
    clickDoc () {
      ContextMenu().hide()
    },
    visibilityChange () {
      // TODO 会触发多次，事件需要外部组件触发
      // document.visibilityState hidden visible
      this.checkMode = false
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/AnswerFileList/ViewFileList.vue